import { useTrackEvent } from "kanopi-components/tracking";
import { useGlobal } from "kanopi-components/useGlobal";

import { replaceIdsWithStoragePaths, getCoverInformation } from "../tracking";

export function useTrackCoverEditStarted({ ...args } = {}) {
  const _trackCoverEditStarted = useTrackEvent({
    event: "Cover Edit Started",
    now: false,
    ...args,
  });
  return function trackCoverEditStarted({ riskProfileId, riskData, cover, ...other }) {
    _trackCoverEditStarted({
      properties: {
        riskProfileId,
        ...getCoverInformation(cover, riskData),
        ...other,
      },
    });
  };
}

export function useTrackCoverAddStarted({ ...args } = {}) {
  const _trackCoverAddStarted = useTrackEvent({
    event: "Cover Add Started",
    now: false,
    ...args,
  });
  return function trackCoverAddStarted({ riskProfileId, riskData, cover, ...other }) {
    _trackCoverAddStarted({
      properties: {
        riskProfileId,
        ...getCoverInformation(cover, riskData),
        ...other,
      },
    });
  };
}

export function useTrackCoverAddCompleted({ ...args } = {}) {
  const [data] = useGlobal("quoting");
  const _trackCoverAddCompleted = useTrackEvent({
    event: "Cover Add Completed",
    now: false,
    ...args,
  });
  return function trackCoverAddCompleted({ riskProfileId, cover, ...other }) {
    _trackCoverAddCompleted({
      properties: {
        riskProfileId,
        ...getCoverInformation(cover, data?.riskProfile?.riskData),
        ...other,
      },
    });
  };
}

export function useTrackCoverRemoved({ ...args } = {}) {
  const _trackCoverRemoved = useTrackEvent({
    event: "Cover Removed",
    now: false,
    ...args,
  });
  return function trackCoverRemoved({ riskProfileId, cover, riskData, ...other }) {
    _trackCoverRemoved({
      properties: {
        riskProfileId,
        ...getCoverInformation(cover, riskData),
        ...other,
      },
    });
  };
}

export function useTrackCoverEdited({ ...args } = {}) {
  const _trackCoverEdited = useTrackEvent({
    event: "Cover Edited",
    now: false,
    ...args,
  });
  return function trackCoverEdited({
    questionSet,
    riskProfileId,
    riskData,
    initialValues,
    answers,
    cover,
    ...other
  }) {
    _trackCoverEdited({
      properties: {
        riskProfileId,
        questionSetName: questionSet.key,
        questionSetId: questionSet.id,
        questionSetIsPrefilled: !!Object.keys(initialValues).length,
        questionSetPrefill: replaceIdsWithStoragePaths(
          initialValues,
          questionSet?.questions
        ),
        // questions: questionSet?.questions, TODO: Find out what properties we need and flatten them
        questionSetAnswers: answers,
        ...getCoverInformation(cover, riskData),
        ...other,
      },
    });
  };
}
